// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"fb0fe29c","23":"ceb770af","136":"f13bfe10","239":"0f04b6af","244":"7e71890c","300":"adaae73d","495":"563faf2f","597":"51760347","771":"4f3ddadf","848":"279960b0","857":"625215cb","867":"cf00b832","879":"2a0b6540","899":"da7dc8a5"}[chunkId] + ".chunk.js";
};